module.exports = __webpack_public_path__ + "img/theif.59ef1287.svg";